import { render, staticRenderFns } from "./TipTapRichTextEditor.vue?vue&type=template&id=4738a89b&scoped=true"
import script from "./TipTapRichTextEditor.vue?vue&type=script&lang=js"
export * from "./TipTapRichTextEditor.vue?vue&type=script&lang=js"
import style0 from "./TipTapRichTextEditor.vue?vue&type=style&index=0&id=4738a89b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4738a89b",
  null
  
)

export default component.exports